<template>
  <div>
    <hshead title="帮助中心" bgcolor="#fff"></hshead>
    <!--将helpImagesText输出到页面中-->
    <div class="hkHelpText">
      <div v-html="helpImagesText"></div>
    </div>
  </div>
</template>

<script>
import hshead from "@/components/common/hshead";
import {
  Toast
} from "vant";
import { getHkHelp } from "@/api/m/store";
import globalMixinBox from "@/assets/js/mixin.js";
import moment from "moment";
import $ from "jquery";
import Vue from "vue";
export default {
  name: "hkHelp",
  mixins: [globalMixinBox.areaMixin],
  data() {
    return {
      StaticWebSite: window.StaticWebSite,
      helpImagesText: "",
      query: this.$route.query,
    };
  },
  created() {
    this.getHkHelp(this.query);
  },
  methods: {
    getHkHelp(query) {
      this.load(true, "加载中...");
      getHkHelp(query)
        .then(response => {
          this.load(false);
          const { code, msg, data } = response;
          if (code >= 0) {
            this.helpImagesText = data.imageText;
          }
        })
        .catch(response => {
          this.load(false);
          Toast.fail({ duration: 1000 * 5, message: `${response.msg}` });
        });
    },
  },
  components: {
    hshead
  }
};
</script>
<style>

.hkHelpText{
  line-height: 0.5 !important;
  padding: 0 20px;
}

.hkHelpText img {
    width: 100%;
}
</style>


// WEBPACK FOOTER //
// src/views/store/hkHelp.vue